export const DobBannerErrorMessageUat = {
  errorMessage: 'workflow.consumerDob.errorMessage',
}
